var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostLaunchMaintenanceExpansion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 135.99 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:#7da2fe;stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3{stroke:#fff;stroke-width:2px;}.cls-3{fill:url(#linear-gradient);stroke-miterlimit:10;}.cls-4{opacity:.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 56.85,
    y1: 54.9,
    x2: 79.14,
    y2: 54.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 59.48,
    y1: 129.39,
    x2: 76.51,
    y2: 129.39,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "arrow3",
    className: "cls-2",
    points: "68 1 1 117.04 33.61 117.04 33.61 154 102.38 154 102.38 117.04 134.99 117.04 68 1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.85,123.59l-8.77-13.76c.29-.9,.57-1.83,.83-2.79,4.96-18.28,.45-56.07,.26-57.67l-.05-.41-19.23-31.84-19.23,31.84-.05,.41c-.19,1.6-4.71,39.39,.26,57.67,.26,.96,.54,1.89,.83,2.79l-8.77,13.76c-1.11,1.74-1.24,3.88-.35,5.74l9.48,19.82c.56,1.16,1.7,1.89,2.98,1.89,1.7,0,3.09-1.22,3.3-2.9l1.8-14.14,.33-.49,1.04,1.71h16.76l1.04-1.71,.33,.49,1.8,14.14c.21,1.68,1.6,2.9,3.3,2.9h0c1.28,0,2.43-.72,2.98-1.89l9.48-19.82c.89-1.86,.76-4-.35-5.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.19,43.76l-18.19-30.13-18.19,30.13s-4.94,40.63,.21,59.61c3.89,14.32,11.13,22.26,11.13,22.26h13.69s7.24-7.93,11.13-22.26c5.15-18.98,.21-59.61,.21-59.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 68,
    cy: 54.9,
    r: 11.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.15,126.46l-3.29,4.93-1.95,15.27c-.19,1.46-2.16,1.77-2.79,.45l-9.92-20.75c-.63-1.31-.53-2.85,.25-4.07l8.27-12.97c3.45,9.5,7.96,15.38,9.43,17.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.27,109.32l8.27,12.97c.78,1.22,.87,2.76,.25,4.07l-9.92,20.75c-.63,1.33-2.6,1.01-2.79-.45l-1.95-15.27-3.29-4.93c1.47-1.76,5.98-7.64,9.43-17.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.84 127.38 68 127.38 61.15 127.38 59.48 129.96 60.35 131.39 68 131.39 75.65 131.39 76.51 129.96 74.84 127.38"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostLaunchMaintenanceExpansion);
export default __webpack_public_path__ + "static/media/post-launch-maintenance-expansion.45fe09040c60b95436387c0aa42bc9d1.svg";
export { ForwardRef as ReactComponent };